import styled from "styled-components";
import color from "../../styles/color";

export const Container = styled.div< { show : boolean, bold?:string } >`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  display: ${(props) => (props.show? 'flex' : 'none')};
  justify-content: center;
  align-items: center;
  background: rgba(0,0,0,0.4);
  ${(props) => props.show && `
        animation: background-out 0.3s;
    `}
  z-index: 9999;
  .modal-body{
    position: absolute;
    ${(props) => props.bold?
      `width: 400px;`  : `width: 600px;`
    }
    
    height: auto;
    padding: 40px 0px;
    text-align: center;
    background-color: ${color.white};
    border-radius: 10px;
    box-shadow: 0 2px 3px 0 rgba(34,36,38,0.15);
    opacity: 1;
    ${(props) => props.show && `
        animation: fade-in 0.3s;
    `}
    .modal-header{
      font-size: 30px;
      font-weight: bold;
      margin-bottom: 50px;
    }
    .modal-content{
        width : 90%;
        ${(props) => props.bold?
          ``
          :
          `
            overflow: auto; 
            height:150px;
            text-align:left;
            border : 2px solid ${color.gray};    
            padding : 10px;   
          `
        }
        
        font-size: 20px;
        margin-left : 30px;
        margin-bottom: 50px;
        .modal-bold{
          color: ${color.red};
          font-weight: bold;
        }
        .modal-text{
          ${(props) => props.bold?
            ``
            :
            ` white-space:pre-line;
            `
          }
        }
    }
    .button-container{
      padding: 0 120px;
      margin: 0 30px;
    }
    .hidden{
      width: 0;
      height: 0;
      padding: 0;
      margin: 0;
      border: 0;
    }
  }

  @keyframes fade-in {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  @keyframes background-out {
    from {
      background: rgba(0,0,0,0);
    }
    to {
      background: rgba(0,0,0,0.4);
    }
  }
`;
